var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.231,
    height: 11.025,
    viewBox: "0 0 13.231 11.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734",
    transform: "translate(-223.382 -271.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M11.99,1.7H10.336C9.923,1.7,9.1,0,8.683,0H4.548C4.093,0,3.266,1.7,2.894,1.7H1.24A1.234,1.234,0,0,0,0,2.968V9.753a1.234,1.234,0,0,0,1.24,1.272H11.99a1.234,1.234,0,0,0,1.24-1.272V2.968A1.234,1.234,0,0,0,11.99,1.7Z",
    transform: "translate(223.382 271.838)",
    fill: "#e75401"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M2.894,5.937A2.844,2.844,0,0,1,.843,5.073,2.991,2.991,0,0,1,0,2.969a2.895,2.895,0,1,1,5.788,0,2.992,2.992,0,0,1-.842,2.1A2.842,2.842,0,0,1,2.894,5.937Zm0-5.089A2.072,2.072,0,0,0,.827,2.969a2.068,2.068,0,1,0,4.135,0A2.072,2.072,0,0,0,2.894.848Z",
    transform: "translate(227.104 274.806)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.533aaf75d0588b48d3e058611feb5746.svg";
export { ForwardRef as ReactComponent };